module.exports = __webpack_public_path__ + "canada.8e3d255a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/canada.jpg
// module id = 1868
// module chunks = 0